import React, { useState } from 'react';
import { toast } from 'react-toastify';

const Login = (props) => {
  const { updateSession } = props;
  const [disabled, setDisabled] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setCredentials({
      ...credentials,
      [name]: val,
    });
  }

  const onLoginHandler = () => {
    const { username, password } = credentials;

    setDisabled(true);

    if ( username === 'app@sjomannskirken.no' && password === 'Nodnumme1' ) {
      var d = new Date();
      var n = d.getTime();
      
      sessionStorage.setItem('session', n);
  
      setDisabled(false);
      updateSession();

      return;
    } else {
      toast.error("Wrong username and/or password!", {
        position: 'top-right'
      });
    }

    setDisabled(false);
  }

  return (
    <div className="container">
      <div className="col-6 offset-3">
        <div className="login-form">
          <div className="form-group">
            <label className="form-label">Username</label>
            <input 
              disabled={disabled} 
              type="text" 
              name="username" 
              className="form-control"
              onChange={(e) => onChangeHandler(e)}
              value={credentials.username}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input 
              disabled={disabled} 
              type="password" 
              name="password" 
              className="form-control"
              onChange={(e) => onChangeHandler(e)}
              value={credentials.password}
            />
          </div>
          <div>
            <button
              disabled={disabled || credentials.username === '' || credentials.password === ''}
              className="btn btn-primary w-100"
              onClick={() => onLoginHandler()}
            >Log in</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;